import React from "react";
import { Helmet } from "react-helmet-async";
import LogoWrapper from "../LogoWrapper/LogoWrapper";
import { useFont } from "../../contexts/FontContext/FontContext";
import { useLocation } from "react-router-dom";
import styles from "./ConfirmationLinkSent.module.css";

const ConfirmationLinkSent = () => {

	const location = useLocation(); // Use the location hook to access the state
    const email = location.state?.email; // Retrieve the email from state
    const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one; 
    
	return (
		<div className={styles.confirmation_link_sent_container}>
			<Helmet>
	        	<title>Confirmation Link Sent</title>
	        </Helmet>
			<LogoWrapper class_={styles.confirmation_link_sent_logo} src={`${process.env.PUBLIC_URL}/images/partial_logo.png`} />
			{email && <p className={`${styles.confirmation_link_sent_text} ${styles.sent_to_email_text} ${fontFamilyOne}`}>Email confirmation sent to {email}.</p>}
			<p className={`${styles.confirmation_link_sent_text} ${styles.check_inbox_text}`}>Please click activation link to log in.</p>
			<p className={`${styles.confirmation_link_sent_text} ${styles.check_spam_text}`}>(Make sure to check your spam!)</p>
		</div>
	);
};

export default ConfirmationLinkSent;